import { render } from "./Products.vue?vue&type=template&id=2be5defb"
import script from "./Products.vue?vue&type=script&scoped=true&lang=js"
export * from "./Products.vue?vue&type=script&scoped=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__